<div class="metric-card" style="flex-grow: 1;">
  <div class="card-body p-0">
    <!-- Fullscreen Spinner Overlay -->

    <div class="CardHeader">
      <div class="d-flex align-items-center">
        <div class="chart-icon-container me-3">
          <i class="bi bi-calculator"></i>
        </div>
        <h3>Cost Allocation</h3>
        <app-tooltip [tooltipId]="'allocation'">
          <i icon class="bi bi-info-circle"></i>
          <div content>
            <p class="text-start">
              <strong>
                This is the cost calculator that enables you to accurately
                assign the costs related to making the product. <br />There are
                different cost categories that you need to make sure you assign
                if you have data for them. <br />Categories are not mandetory to
                fill in, if no cost for that category then you can leave it out.
                <br />Click the pencil to edit existing items in the table rows.
                <br />
                Remember you must save twice, i.e. inline for each row, and
                using the big save button.<br />Each row have a save button.<br />Save
                click the inline button once you are happy with changes.<br />Remember
                to click the big Save button when you are happy with the changes
                on this page.
              </strong>
            </p>
          </div>
        </app-tooltip>
      </div>
      <div class="dropdown d-flex align-items-center">
        <div class="input-group" style="height: 45px; width: 500px">
          <!-- Custom product dropdown toggle styled like a select -->
          <button
            type="button"
            id="productSelectBtn"
            class="form-control text-start d-flex align-items-center justify-content-between fw-semibold"
            #productBtn
            (mousedown)="onProductToggleMouseDown(productBtn, $event)"
            (click)="$event.stopPropagation()"
            aria-haspopup="listbox"
            [attr.aria-expanded]="productDropdownOpen"
            [attr.aria-controls]="'productSelectMenu'"
          >
            <span class="text-truncate">
              {{ getSelectedProductDisplay() }}
            </span>
            <i
              class="bi ms-2"
              [ngClass]="{
                'bi-chevron-down': !productDropdownOpen,
                'bi-chevron-up': productDropdownOpen
              }"
            ></i>
          </button>

          <!-- Custom dropdown menu -->
          <div
            class="card shadow-sm mt-1"
            [id]="'productSelectMenu'"
            *ngIf="productDropdownOpen"
            role="listbox"
            (mousedown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
            [ngStyle]="{
              position: 'fixed',
              zIndex: 2147483647,
              top:
                (productDropdownStyles && productDropdownStyles.top) || '0',
              left:
                (productDropdownStyles && productDropdownStyles.left) || '0',
              width: productDropdownStyles
                ? 'calc(' + productDropdownStyles.width + ' + 15%)'
                : '100%'
            }"
            style="border-radius: 0.375rem; max-height: 260px; overflow: hidden; pointer-events: auto;"
          >
            <div class="p-2 border-bottom bg-white">
              <input
                type="text"
                class="form-control form-control-sm rm-search-input"
                placeholder="Search products..."
                aria-label="Search products"
                [(ngModel)]="productSearchText"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="onProductSearchChange()"
                (keydown.escape)="productDropdownOpen = false"
                autofocus
              />
            </div>
            <!-- Create new product (top of dropdown for calculator accounts) -->
            <div *ngIf="!showCreateProductInput && accountType === 'calculator'" class="border-bottom">
              <button
                type="button"
                class="list-group-item list-group-item-action d-flex align-items-center text-primary"
                (click)="showCreateProduct(); $event.stopPropagation()"
              >
                <i class="bi bi-plus-circle me-2"></i>
                Create New Product
              </button>
            </div>

            <!-- Inline create product form -->
            <div *ngIf="showCreateProductInput" class="p-2 border-bottom bg-light">
              <div class="d-flex flex-column gap-2">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Product name"
                  [(ngModel)]="newProductName"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown.escape)="cancelCreateProduct()"
                  autofocus
                />
                <input
                  type="number"
                  class="form-control form-control-sm"
                  placeholder="Target selling price"
                  [(ngModel)]="newProductSellingPrice"
                  [ngModelOptions]="{ standalone: true }"
                  (keydown.enter)="createProduct()"
                  (keydown.escape)="cancelCreateProduct()"
                  min="0"
                  step="0.01"
                />
                <div class="d-flex gap-2">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary flex-grow-1"
                    (click)="createProduct()"
                    [disabled]="isCreatingProduct || !newProductName.trim() || !newProductSellingPrice || newProductSellingPrice <= 0"
                  >
                    {{ isCreatingProduct ? 'Creating...' : 'Create Product' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    (click)="cancelCreateProduct()"
                    [disabled]="isCreatingProduct"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div
              class="list-group list-group-flush"
              style="max-height: 210px; overflow-y: auto;"
            >
              <button
                type="button"
                class="list-group-item list-group-item-action"
                (click)="selectProduct(null)"
              >
                Select Product
              </button>
              <button
                type="button"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                *ngFor="let product of productPaged"
                (click)="selectProduct(product)"
                role="option"
                [attr.aria-selected]="selectedProductId === product.itemID"
              >
                <span class="text-truncate">{{ product.itemName }}</span>
                <i
                  *ngIf="selectedProductId === product.itemID"
                  class="bi bi-check2 text-success ms-2"
                ></i>
              </button>
              <div
                *ngIf="filteredProducts.length === 0 && !showCreateProductInput"
                class="p-2 text-muted small"
              >
                No matches
              </div>
              <div
                *ngIf="productTotalPages > 1"
                class="d-flex justify-content-between align-items-center p-2 border-top bg-white"
              >
                <small class="text-muted"
                  >Page {{ productCurrentPage }} of
                  {{ productTotalPages }}</small
                >
                <nav aria-label="Products pagination">
                  <ul class="pagination pagination-sm mb-0">
                    <li
                      class="page-item"
                      [class.disabled]="productCurrentPage === 1"
                    >
                      <button
                        type="button"
                        class="page-link"
                        (click)="changeProductPage(productCurrentPage - 1)"
                        aria-label="Previous"
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </button>
                    </li>
                    <li
                      class="page-item"
                      *ngFor="let page of productPages"
                      [class.active]="page === productCurrentPage"
                    >
                      <button
                        type="button"
                        class="page-link"
                        (click)="changeProductPage(page)"
                      >
                        {{ page }}
                      </button>
                    </li>
                    <li
                      class="page-item"
                      [class.disabled]="
                        productCurrentPage === productTotalPages
                      "
                    >
                      <button
                        type="button"
                        class="page-link"
                        (click)="changeProductPage(productCurrentPage + 1)"
                        aria-label="Next"
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <app-tooltip [tooltipId]="'select-product'">
          <i icon class="bi bi-info-circle"></i>
          <div content>
            <p class="text-start">
              <strong>
                This is where you select the Product that you added in the
                Inventory Dashboard that you want to do cost calculations
                for.<br />
                <strong class="tooltipTextColor"
                  >To use this first add products in the Inventory
                  Dashboard.</strong
                >
              </strong>
            </p>
          </div>
        </app-tooltip>
        <!-- Edit Product Button (desktop) -->
        <button
          *ngIf="selectedProductId"
          type="button"
          class="btn btn-outline-secondary ms-2"
          style="height: 45px; width: 45px; padding: 0; flex-shrink: 0;"
          title="Edit Product"
          (click)="openEditProduct()"
        >
          <i class="bi bi-pencil-square"></i>
        </button>
      </div>
      <button
        class="btn btn-teal-gradient px-4 py-2 rounded-1"
        (click)="openSaveConfirmation()"
      >
        <i class="bi bi-floppy fs-5"></i> <span class="ml-2 fs-5">Save</span>
      </button>
    </div>

    <div class="row g-3 mb-2 align-items-center" style="margin-top: 0.5%">
      <!-- Product selection dropdown -->

      <!-- Target Total Cost -->
      <div class="col-xl-4 col-lg-3 col-md-6 col-12">
        <div class="d-flex align-items-center">
          <div class="input-group" style="height: 45px">
            <!-- Input first, so it's on the left -->
            <input
              id="targetCostInput"
              #targetInput
              type="number"
              class="form-control text-center border-end-0 border-start-0"
              [ngModel]="targetTotalCost"
              (ngModelChange)="onTargetCostChange($event)"
              min="0"
              step="0.01"
              (focus)="targetInput.placeholder = ''"
              (blur)="targetInput.placeholder = ''"
              (wheel)="$event.preventDefault()"
            />
            <!-- Then the label on the right -->
            <span class="input-group-text bg-white border-start-0 fw-semibold">
              Target Total Cost
            </span>
          </div>
          <app-tooltip [tooltipId]="'target-cost'">
            <i icon class="bi bi-info-circle"></i>
            <div content>
              <p class="text-start">
                <strong>
                  The total cost of production for the item that you do not want
                  to exceed when making the item or the service.<br />
                  <strong class="tooltipTextColor"
                    >This is different from selling price.</strong
                  >
                </strong>
              </p>
            </div>
          </app-tooltip>
        </div>
      </div>

      <!-- Search Input -->
      <div class="col-xl-4 col-lg-3 col-md-6 col-12">
        <div class="d-flex align-items-center">
          <div class="input-group" style="height: 45px">
            <input
              type="text"
              id="searchInput"
              class="form-control"
              placeholder="Search..."
              (input)="onSearchChange($event)"
            />
            <span class="input-group-text">
              <i class="bi bi-search"></i>
            </span>
          </div>
          <app-tooltip [tooltipId]="'search'">
            <i icon class="bi bi-info-circle"></i>
            <div content>
              <p class="text-start">
                <strong>
                  This is where you can search your entries on the table by
                  Name.<br />
                  <strong class="tooltipTextColor"
                    >For any category you can use the search button.</strong
                  >
                </strong>
              </p>
            </div>
          </app-tooltip>
        </div>
      </div>

      <!-- Markup slider -->
      <div class="col-xl-4 col-lg-12 col-md-12 col-12 align-items-start">
        <div
          class="d-flex align-items-center gap-3 p-2 border bg-white"
          style="height: 45px"
        >
          <label
            for="markupSlider"
            class="form-label mb-0 text-nowrap small fw-medium flex-shrink-0"
          >
            <div class="d-flex align-items-center">
              <span>Markup Percent:</span>
              <!-- this span will always occupy exactly 4 characters worth of space -->
              <span
                class="markup-value d-inline-block text-end ms-2 text-primary fw-semibold"
              >
                {{ formatNumber(markupPercent) }}%
              </span>
            </div>
          </label>
          <input
            type="range"
            id="markupSlider"
            class="form-range flex-grow-1"
            min="0"
            max="300"
            step="0.1"
            [(ngModel)]="markupPercent"
            (input)="onSliderInput($event)"
            (change)="onSliderChange($event)"
          />
          <input
            type="text"
            class="form-control form-control-sm flex-shrink-0"
            style="width: 70px"
            [(ngModel)]="displayValue"
            (input)="onDirectInput($event)"
            (blur)="onMarkupPercentChange()"
            (focus)="onInputFocus()"
            placeholder="0.0"
            inputmode="decimal"
          />
        </div>
      </div>
      <!-- tabs  -->
      <div
        id="selectionlist"
        style="
          width: 100%;
          min-width: 265px;
          max-height: 355px;
          display: flex;
          flex-direction: row;
          overflow: hidden;
        "
      >
        <ul
          class="nav nav-tabs-modern d-flex flex-row gap-2"
          id="costTabs"
          style="overflow: hidden"
        >
          <li
            class="nav-item"
            *ngFor="let tab of tabs"
            style="min-width: max-content"
          >
            <a
              class="nav-link d-flex justify-content-between align-items-center px-2"
              [class.active]="tab.active"
              (click)="setActiveTab(tab)"
              data-bs-toggle="tab"
              [href]="'#' + tab.id"
              style="font-size: 0.85rem"
            >
              <span class="text-start">
                {{ tab.label }}
              </span>
              <span class="badge">
                {{ getCount(tab.id) }}
              </span>
            </a>
          </li>
        </ul>
      </div>

      <div class="">
        <div class="flex-grow-1" style="overflow-x: auto">
          <div class="tab-content" style="padding-top: 5px">
            <div id="materials" class="tab-pane fade show active">
              <div class="border">
                <!-- Table header only -->
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed"
                >
                  <thead class="sticky-top table-header rounded-2">
                    <tr>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Mat Name
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Purch. Price
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Purch. Qty
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Price/U
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Qty Required
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Batch Size
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Unit Cost
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span>Actions</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>

                <!-- Scrollable body only -->
                <div class="scrollable-content">
                  <table
                    class="table table-hover align-middle mb-0"
                    style="table-layout: fixed"
                  >
                    <tbody>
                      <tr>
                        <td colspan="8" class="text-center">
                          <button
                            *ngIf="selectedProductId"
                            class="btn btn-teal-gradient btn-sm text"
                            (click)="addNewMaterial()"
                          >
                            <i class="bi bi-plus"></i> Add New Entry
                          </button>
                          <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                            {{ accountType === 'calculator' ? 'Create or select a product above to add materials' : 'Select a product above or create one in Inventory' }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        *ngFor="
                          let item of filteredMaterialItems;
                          let i = index
                        "
                        class="hover-highlight"
                      >
                        <!-- 1) Name -->
                        <td class="py-2 fw-semibold">
                          <ng-container
                            *ngIf="item.isNew || item.isEditing; else nameText"
                          >
                            <!-- Full plan: pick from inventory raw materials -->
                            <select
                              *ngIf="accountType !== 'calculator'; else nameInput"
                              class="form-control form-control-sm custom-select"
                              [(ngModel)]="item.inventoryId"
                              (ngModelChange)="onMaterialNameSelect(item, $event)"
                            >
                              <option [ngValue]="0" disabled>
                                Select material
                              </option>
                              <option
                                *ngFor="let opt of materialDropdownOptions"
                                [ngValue]="opt.itemID"
                              >
                                {{ opt.itemName }}
                              </option>
                            </select>
                            <!-- Calculator-only plan: free-text name -->
                            <ng-template #nameInput>
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [(ngModel)]="item.itemName"
                                placeholder="Enter name"
                              />
                            </ng-template>
                          </ng-container>
                          <ng-template #nameText>{{
                            item.itemName
                          }}</ng-template>
                        </td>

                        <!-- 2) Purch. Price -->
                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isNew || item.isEditing; else priceText"
                          >
                            <div
                              class="input-group input-group-sm"
                              style="max-width: 120px"
                            >
                              <span class="input-group-text">R</span>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                [(ngModel)]="item.purchasePrice"
                                (ngModelChange)="onMaterialChange(item)"
                                (focus)="clearZero($event)"
                                (blur)="restoreZeroIfEmpty($event)"
                                min="0"
                                step="0.01"
                              />
                            </div>
                          </ng-container>
                          <ng-template #priceText>
                            R{{
                              item.purchasePrice | number : "1.2-2" : "en-US"
                            }}
                          </ng-template>
                        </td>

                        <!-- 3) Purch. Qty -->
                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isNew || item.isEditing; else qtyText"
                          >
                            <div class="fused-input-group">
                              <app-area-quantity-input
                                [uomCode]="item.purchaseUnit"
                                [(value)]="item.purchaseQuantity"
                                cssClass="fused-input"
                                (valueChange)="onMaterialChange(item)"
                              />
                              <div class="fused-unit-select-wrapper">
                                <select
                                  class="fused-unit-select"
                                  [(ngModel)]="item.purchaseUnit"
                                  (ngModelChange)="onPurchaseUnitChange(item, $event)"
                                >
                                  <option value="" disabled>UOM</option>
                                  <option *ngFor="let uom of getAllUOMs()" [value]="uom.uomCode">
                                    {{ uom.uomName }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #qtyText>
                            <div class="d-flex align-items-center gap-1">
                              <span>{{
                                item.purchaseQuantity
                                  | number : "1.0-2" : "en-US"
                              }}</span>
                              <small class="text-muted">{{
                                getQtyLabel(
                                  item.purchaseQuantity,
                                  item.purchaseUnit
                                )
                              }}</small>
                            </div>
                          </ng-template>
                        </td>

                        <!-- 4) Price/Unit -->
                        <td class="py-2 fw-semibold">
                          <span *ngIf="item.purchaseUOMID; else noUnit">
                            R{{
                              item.purchasePricePerUnit
                                | number : "1.2-2" : "en-US"
                            }}/{{ getUnitDisplay(item.purchaseUOMID) }}
                          </span>
                          <ng-template #noUnit>
                            R{{
                              item.purchasePricePerUnit
                                | number : "1.2-2" : "en-US"
                            }}
                          </ng-template>
                        </td>

                        <!-- 5) Usage Qty -->
                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isNew || item.isEditing; else usageText"
                          >
                            <div class="fused-input-group">
                              <app-area-quantity-input
                                [uomCode]="item.usageUnit"
                                [(value)]="item.usageQuantity"
                                cssClass="fused-input"
                                (valueChange)="onMaterialChange(item)"
                              />
                              <div class="fused-unit-select-wrapper">
                                <select
                                  class="fused-unit-select"
                                  [(ngModel)]="item.usageUnit"
                                  (ngModelChange)="onUsageUnitChange(item, $event)"
                                >
                                  <option value="" disabled>UOM</option>
                                  <option *ngFor="let uom of getCompatibleUOMs(item.purchaseUnit)" [value]="uom.uomCode">
                                    {{ uom.uomName }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #usageText>
                            <div class="d-flex align-items-center gap-1">
                              <span>{{
                                item.usageQuantity | number : "1.2-2" : "en-US"
                              }}</span>
                              <small class="text-muted">{{
                                getQtyLabel(item.usageQuantity, item.usageUnit)
                              }}</small>
                            </div>
                          </ng-template>
                        </td>

                        <!-- 6) Batch Size -->
                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isNew || item.isEditing; else unitsText"
                          >
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              style="max-width: 80px"
                              [(ngModel)]="item.batchSize"
                              (ngModelChange)="onMaterialChange(item)"
                              (focus)="clearZero($event)"
                              min="1"
                              step="1"
                            />
                          </ng-container>
                          <ng-template #unitsText>
                            {{ item.batchSize }}&nbsp;
                            <small class="text-muted">{{
                              item.batchSize === 1 ? "unit" : "units"
                            }}</small>
                          </ng-template>
                        </td>

                        <!-- 7) Unit Cost -->
                        <td class="py-2 text-success fw-semibold">
                          R{{ item.unitCost | number : "1.2-2" : "en-US" }}
                        </td>

                        <!-- 8) Actions -->
                        <td class="py-2 text-nowrap text-start ps-3">
                          <button
                            *ngIf="item.isNew || item.isEditing"
                            class="btn-outline-primary success"
                            (click)="saveMaterialRow(item)"
                            title="Save"
                          >
                            <i class="bi bi-floppy"></i>
                          </button>
                          <button
                            *ngIf="!item.isNew && !item.isEditing"
                            class="btn-outline-primary"
                            (click)="startEditMaterial(i)"
                            title="Edit"
                          >
                            <i class="bi bi-pencil-square"></i>
                          </button>
                          <button
                            class="btn-outline-primary danger"
                            (click)="deleteItem(item, 'materials', i)"
                            title="Delete"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>

                      <tr *ngIf="showAlert">
                        <td colspan="8" style="padding: 0">
                          <div
                            class="custom-alert alert-dismissible fade show shadow-lg mt-2"
                            role="alert"
                          >
                            <div class="alert-content">
                              <div class="alert-body">
                                <h4 class="alert-heading">
                                  ⚠️ Target Exceeded
                                </h4>
                                <div
                                  class="alert-message"
                                  [innerHTML]="alertMessage"
                                ></div>
                              </div>
                              <button
                                type="button"
                                class="btn-close alert-close"
                                aria-label="Close"
                                (click)="showAlert = false"
                              ></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Updated Fixed Overheads Tab -->
            <div
              id="fixed"
              class="tab-pane fade"
              [class.show]="isActive('fixed')"
              [class.active]="isActive('fixed')"
            >
              <div
                *ngIf="fohBatchChangePending"
                class="alert alert-warning d-flex align-items-center justify-content-between py-2 px-3 mb-2"
                role="alert"
              >
                <span>
                  Batch size updated — changes not yet saved.
                </span>
                <button class="btn btn-sm btn-warning ms-3" (click)="saveAllFixedRows()">
                  Save All
                </button>
              </div>
              <div class="border shadow-sm">
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed"
                >
                  <thead class="bg-neutral-800 sticky-top z-3">
                    <tr>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        FOH Name
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Cost PM (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Hrs Open PM
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Rate/min (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Min/Batch
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Batch Size
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold py-3"
                      >
                        Unit Cost (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header"
                      >
                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span>Actions</span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </table>
                <!-- scrollable table body content -->
                <div class="scrollable-content">
                  <table
                    class="table table-hover align-middle mb-0"
                    style="table-layout: fixed"
                  >
                    <tbody>
                      <tr>
                        <td colspan="8" class="text-center">
                          <button
                            *ngIf="selectedProductId"
                            class="btn btn-teal-gradient btn-sm text"
                            (click)="addNewFixed()"
                          >
                            <i class="bi bi-plus"></i> Add New Entry
                          </button>
                          <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                            {{ accountType === 'calculator' ? 'Create or select a product first' : 'Select a product or create one in Inventory' }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        *ngFor="let item of filteredFixedItems"
                        class="hover-highlight"
                        [class.text-muted]="item.isPlaceholder"
                      >
                        <td class="py-2 fw-semibold">
                          <select
                            *ngIf="
                              item.isNew || item.isEditing;
                              else itemNameText
                            "
                            class="form-control form-control-sm custom-select"
                            [(ngModel)]="item.overheadCostItemID"
                            (ngModelChange)="onFOHNameChange(item, $event)"
                          >
                            <option [ngValue]="null" disabled>
                              Select Overhead
                            </option>
                            <option
                              *ngFor="let overhead of fixedOverheadNames"
                              [ngValue]="overhead.overheadCostItemID"
                            >
                              {{ overhead.overheadName }}
                            </option>
                          </select>
                          <ng-template #itemNameText>
                            {{ item.itemName }}
                          </ng-template>
                        </td>

                        <td class="py-2">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else costPerMonthText
                            "
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.costPerMonth"
                            (ngModelChange)="onFOHChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="0.01"
                            readonly
                            title="Auto-calculated based on allocation rate and period type"
                          />
                          <ng-template #costPerMonthText>
                            R{{
                              item.costPerMonth | number : "1.2-2" : "en-US"
                            }}
                          </ng-template>
                        </td>

                        <td class="py-2">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else hoursOpenText
                            "
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.hoursOpenPerMonth"
                            (ngModelChange)="onFOHChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                            readonly
                          />
                          <ng-template #hoursOpenText>
                            {{ item.hoursOpenPerMonth }}
                          </ng-template>
                        </td>

                        <td class="py-2 fw-semibold text-start">
                          R{{ item.ratePerMinute | number : "1.2-2" : "en-US" }}
                        </td>

                        <td class="py-2">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else minutesPerJobText
                            "
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.minutesPerOrder"
                            (ngModelChange)="onSharedBatchChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                          />
                          <ng-template #minutesPerJobText>
                            {{ item.minutesPerOrder }}
                          </ng-template>
                        </td>
                        <td class="py-2">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else batchSizeText
                            "
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.batchSize"
                            (ngModelChange)="onSharedBatchChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                          />
                          <ng-template #batchSizeText>
                            {{
                              item.batchSize !== null &&
                              item.batchSize !== undefined
                                ? item.batchSize
                                : "—"
                            }}
                          </ng-template>
                        </td>

                        <td class="py-2 fw-semibold text-start">
                          R{{ item.unitCost | number : "1.2-2" : "en-US" }}
                        </td>

                        <td class="py-2 text-nowrap">
                          <button
                            *ngIf="item.isNew || item.isEditing"
                            class="btn-outline-primary success"
                            (click)="saveFixedRow(item)"
                            title="Save"
                          >
                            <i class="bi bi-floppy"></i>
                          </button>

                          <button
                            *ngIf="!item.isNew && !item.isEditing"
                            class="btn-outline-primary"
                            (click)="startEditFixedItem(item)"
                            title="Edit"
                          >
                            <i class="bi bi-pencil-square"></i>
                          </button>

                          <button
                            *ngIf="!item.isPlaceholder"
                            class="btn-outline-primary danger"
                            (click)="removeFixedOverheadItem(item)"
                            title="Delete"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>

                      <tr *ngIf="showAlert">
                        <td colspan="8" style="padding: 0">
                          <div
                            class="custom-alert alert-dismissible fade show shadow-lg mt-2"
                            role="alert"
                          >
                            <div class="alert-content">
                              <div class="alert-body">
                                <h4 class="alert-heading">
                                  ⚠️ Target Exceeded
                                </h4>
                                <div
                                  class="alert-message"
                                  [innerHTML]="alertMessage"
                                ></div>
                              </div>
                              <button
                                type="button"
                                class="btn-close alert-close"
                                aria-label="Close"
                                (click)="showAlert = false"
                              ></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- Direct Labour Tab -->

            <div
              id="labour"
              class="tab-pane fade"
              [class.show]="isActive('labour')"
              [class.active]="isActive('labour')"
            >
              <div
                class="table-responsive border shadow-sm"
                style="max-height: 330px; overflow-y: auto"
              >
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed; width: 100%"
                >
                  <thead class="bg-neutral-800 sticky-top z-3">
                    <tr>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 12%; min-width: 120px"
                      >
                        Employee
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 11%; min-width: 80px"
                      >
                        Role
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        Salary (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 7%; min-width: 60px"
                      >
                        Hrs Wrkd
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 9%; min-width: 70px"
                      >
                        Rate Type
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        Rate / min (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 10%; min-width: 90px"
                      >
                        Activity
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 7%; min-width: 60px"
                      >
                        Min / Act
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 7%; min-width: 70px"
                      >
                        Batch Size
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        Unit Cost (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header text-start"
                        style="width: 10%"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="11" class="text-center">
                        <button
                          *ngIf="selectedProductId"
                          class="btn btn-teal-gradient btn-sm text"
                          (click)="addNewLabour()"
                        >
                          <i class="bi bi-plus"></i> Add New Entry
                        </button>
                        <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                          {{ accountType === 'calculator' ? 'Create or select a product first' : 'Select a product or create one in Inventory' }}
                        </span>
                      </td>
                    </tr>

                    <tr
                      *ngFor="
                        let item of labourItems;
                        let i = index;
                        trackBy: trackLabourItem
                      "
                      class="hover-highlight"
                    >
                      <td
                        class="py-2 fw-semibold text-start"
                        style="width: 12%; min-width: 120px"
                      >
                        <ng-container
                          *ngIf="item.isNew || item.isEditing; else empText"
                        >
                          <select
                            class="form-select form-select-sm"
                            [(ngModel)]="item.employeeID"
                            (ngModelChange)="onEmployeeSelect(item)"
                          >
                            <option [ngValue]="null" disabled>
                              Select employee
                            </option>
                            <option
                              *ngFor="let emp of employees"
                              [ngValue]="emp.employeeID"
                            >
                              {{ emp.firstName }} {{ emp.lastName }}
                            </option>
                          </select>
                        </ng-container>
                        <ng-template #empText>{{
                          item.employeeName || "—"
                        }}</ng-template>
                      </td>

                      <td
                        class="py-2 fw-semibold text-start"
                        style="width: 11%; min-width: 80px"
                      >
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <input
                            *ngIf="item.isNew || item.isEditing"
                            type="text"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.roleDescription"
                            (ngModelChange)="onRoleChange(item)"
                            placeholder="Role"
                            readonly
                          />
                          <span *ngIf="!item.isNew && !item.isEditing">
                            {{ item.roleDescription || "—" }}
                          </span>
                        </div>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        <div
                          *ngIf="item.isNew || item.isEditing; else salaryText"
                          class="input-group input-group-sm justify-content-start"
                          style="max-width: 120px; margin: 0 auto"
                        >
                          <span class="input-group-text">R</span>
                          <input
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.monthlySalary"
                            (ngModelChange)="onLabourChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="0.01"
                            readonly
                          />
                        </div>
                        <ng-template #salaryText>
                          R{{ item.monthlySalary | number : "1.2-2" : "en-US" }}
                        </ng-template>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 7%; min-width: 60px"
                      >
                        <input
                          *ngIf="item.isNew || item.isEditing; else hoursText"
                          type="number"
                          class="form-control form-control-sm text-start"
                          [(ngModel)]="item.hoursWorkedPm"
                          (ngModelChange)="onLabourChange(item)"
                          (focus)="clearZero($event)"
                          (blur)="restoreZeroIfEmpty($event)"
                          min="0"
                          step="0.1"
                          readonly
                        />
                        <ng-template #hoursText>
                          {{
                            item.hoursWorkedPm != null
                              ? (item.hoursWorkedPm
                                | number : "1.2-2" : "en-US")
                              : "—"
                          }}
                        </ng-template>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 9%; min-width: 70px"
                      >
                        <span>{{ item.rateType || "—" }}</span>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        R{{ item.ratePerMinute | number : "1.2-2" : "en-US" }}
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 10%; min-width: 90px"
                      >
                        <input
                          *ngIf="
                            item.isNew || item.isEditing;
                            else activityText
                          "
                          type="text"
                          class="form-control form-control-sm text-start"
                          [(ngModel)]="item.activity"
                          placeholder="Activity Descr"
                          (focus)="clearZero($event)"
                        />
                        <ng-template #activityText>
                          {{ item.activity || "—" }}
                        </ng-template>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 7%; min-width: 60px"
                      >
                        <input
                          *ngIf="item.isNew || item.isEditing; else minsText"
                          type="number"
                          class="form-control form-control-sm text-start"
                          [(ngModel)]="item.minutesPerJob"
                          (ngModelChange)="onLabourChange(item)"
                          (focus)="clearZero($event)"
                          (blur)="restoreZeroIfEmpty($event)"
                          min="0"
                          step="1"
                        />
                        <ng-template #minsText>{{
                          item.minutesPerJob
                        }}</ng-template>
                      </td>

                      <td
                        class="py-2 text-start"
                        style="width: 7%; min-width: 70px"
                      >
                        <div
                          *ngIf="item.isNew || item.isEditing; else batchText"
                          class="input-group input-group-sm justify-content-start"
                          style="max-width: 120px; margin: 0 auto"
                        >
                          <input
                            type="number"
                            class="form-control form-control-sm text-start"
                            [(ngModel)]="item.batchSize"
                            (ngModelChange)="onLabourChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                          />
                        </div>
                        <ng-template #batchText>
                          {{ item.batchSize | number : "1.0-2" : "en-US" }}
                        </ng-template>
                      </td>

                      <td
                        class="py-2 fw-semibold text-start"
                        style="width: 9%; min-width: 80px"
                      >
                        R{{ item.unitCost | number : "1.2-2" : "en-US" }}
                      </td>

                      <td
                        class="py-2 text-nowrap text-start"
                        style="width: 6%; min-width: 100px"
                      >
                        <button
                          *ngIf="item.isNew || item.isEditing"
                          class="btn-outline-primary success"
                          (click)="saveLabourRow(item)"
                          title="Save"
                        >
                          <i class="bi bi-floppy"></i>
                        </button>

                        <button
                          *ngIf="!item.isNew && !item.isEditing"
                          class="btn-outline-primary"
                          (click)="startEditLabour(i)"
                          title="Edit"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>

                        <button
                          class="btn-outline-primary danger"
                          (click)="removeLabour(i)"
                          title="Delete"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <tr *ngIf="showAlert">
                      <td colspan="11" style="padding: 0">
                        <div
                          class="custom-alert alert-dismissible fade show shadow-lg mt-2"
                          role="alert"
                        >
                          <div class="alert-content">
                            <div class="alert-body">
                              <h4 class="alert-heading">⚠️ Target Exceeded</h4>
                              <div
                                class="alert-message"
                                [innerHTML]="alertMessage"
                              ></div>
                            </div>
                            <button
                              type="button"
                              class="btn-close alert-close"
                              aria-label="Close"
                              (click)="showAlert = false"
                            ></button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Indirect Labour Tab -->
            <div
              id="indirect-labour"
              class="tab-pane fade"
              [class.show]="isActive('indirect-labour')"
              [class.active]="isActive('indirect-labour')"
            >
              <div class="border shadow-sm">
                <!-- Fixed Header Table -->
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed"
                >
                  <thead class="bg-neutral-800 sticky-top z-3">
                    <tr>
                      <!-- New Employee column header -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Employee
                      </th>
                      <!-- Existing Role column -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Role
                      </th>
                      <!-- Salary PM -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Salary PM (R)
                      </th>
                      <!-- Hours PM -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Hrs PM
                      </th>
                      <!-- Rate Type -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Rate Type
                      </th>
                      <!-- Rate / min -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Rate / min (R)
                      </th>
                      <!-- Activity -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Activity
                      </th>
                      <!-- Min / Activity -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Min / Activity
                      </th>
                      <!-- Batch Size -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Batch Size
                      </th>
                      <!-- Unit Cost -->
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Unit Cost (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                </table>

                <!-- Scrollable Body -->
                <div class="scrollable-content">
                  <table
                    class="table table-hover align-middle mb-0"
                    style="table-layout: fixed"
                  >
                    <tbody>
                      <tr>
                        <td colspan="11" class="text-center">
                          <button
                            *ngIf="selectedProductId"
                            class="btn btn-teal-gradient btn-sm text"
                            (click)="addNewIndirectLabour()"
                          >
                            <i class="bi bi-plus"></i> Add New Entry
                          </button>
                          <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                            {{ accountType === 'calculator' ? 'Create or select a product first' : 'Select a product or create one in Inventory' }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        *ngFor="
                          let item of filteredIndirectLabourItems;
                          let i = index;
                          trackBy: trackLabourItem
                        "
                        class="hover-highlight"
                      >
                        <!-- 1) Employee -->
                        <td class="py-2 fw-semibold align-middle">
                          <ng-container
                            *ngIf="
                              item.isNew || item.isEditing;
                              else empTextIndirect
                            "
                          >
                            <select
                              class="form-select form-select-sm w-100"
                              [(ngModel)]="item.employeeID"
                              (ngModelChange)="onEmployeeSelect(item)"
                            >
                              <option [ngValue]="null" disabled selected>
                                Select employee
                              </option>
                              <option
                                *ngFor="let emp of employees"
                                [ngValue]="emp.employeeID"
                              >
                                {{ emp.firstName }} {{ emp.lastName }}
                              </option>
                            </select>
                          </ng-container>
                          <ng-template #empTextIndirect>
                            {{ item.employeeName || "—" }}
                          </ng-template>
                        </td>

                        <!-- 2) Role -->
                        <td class="py-2 align-middle">
                          <input
                            *ngIf="item.isNew || item.isEditing"
                            type="text"
                            class="form-control form-control-sm"
                            [(ngModel)]="item.roleDescription"
                            (ngModelChange)="onRoleChange(item)"
                            placeholder="Role"
                            readonly
                          />
                          <span *ngIf="!item.isNew && !item.isEditing">
                            {{ item.roleDescription || "—" }}
                          </span>
                        </td>

                        <!-- 3) Salary PM -->
                        <td class="py-2 align-middle">
                          <ng-container
                            *ngIf="
                              item.isNew || item.isEditing;
                              else salaryText
                            "
                          >
                            <div
                              class="input-group input-group-sm"
                              style="max-width: 120px"
                            >
                              <span class="input-group-text">R</span>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                [(ngModel)]="item.monthlySalary"
                                (ngModelChange)="onIndirectChange(item)"
                                (focus)="clearZero($event)"
                                (blur)="restoreZeroIfEmpty($event)"
                                min="0"
                                step="0.01"
                                readonly
                              />
                            </div>
                          </ng-container>
                          <ng-template #salaryText>
                            {{
                              item.monthlySalary != null &&
                              item.monthlySalary > 0
                                ? "R" +
                                  (item.monthlySalary
                                    | number : "1.2-2" : "en-US")
                                : "—"
                            }}
                          </ng-template>
                        </td>
                        <td class="py-2">
                          <input
                            *ngIf="item.isNew || item.isEditing; else hoursText"
                            type="number"
                            class="form-control form-control-sm"
                            style="max-width: 100px"
                            [(ngModel)]="item.hoursWorkedPm"
                            (ngModelChange)="onIndirectChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            readonly
                            min="0"
                            step="0.1"
                          />
                          <ng-template #hoursText>
                            {{
                              item.hoursWorkedPm != null
                                ? (item.hoursWorkedPm
                                  | number : "1.0-2" : "en-US")
                                : "—"
                            }}
                          </ng-template>
                        </td>
                        <!-- 4) Hours PM -->

                        <!-- 5) Rate Type -->
                        <td class="py-2 align-middle">
                          {{ item.rateType || "—" }}
                        </td>

                        <!-- 6) Rate / min -->
                        <td class="py-2 fw-semibold align-middle">
                          R{{ item.ratePerMinute | number : "1.2-2" : "en-US" }}
                        </td>

                        <!-- 7) Activity -->
                        <td class="py-2 align-middle">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else activityTextIndirect
                            "
                            type="text"
                            class="form-control form-control-sm"
                            [(ngModel)]="item.activity"
                            placeholder="Activity Descr"
                            (focus)="clearZero($event)"
                          />
                          <ng-template #activityTextIndirect>
                            {{ item.activity || "—" }}
                          </ng-template>
                        </td>

                        <!-- 8) Minutes / Activity -->
                        <td class="py-2 align-middle">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else minsTextIndirect
                            "
                            type="number"
                            class="form-control form-control-sm"
                            style="max-width: 100px"
                            [(ngModel)]="item.minutesPerActivity"
                            (ngModelChange)="onIndirectChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                          />
                          <ng-template #minsTextIndirect>
                            {{
                              item.minutesPerActivity != null
                                ? item.minutesPerActivity
                                : "—"
                            }}
                          </ng-template>
                        </td>

                        <!-- 9) Batch Size -->
                        <td class="py-2 align-middle">
                          <input
                            *ngIf="
                              item.isNew || item.isEditing;
                              else batchTextIndirect
                            "
                            type="number"
                            class="form-control form-control-sm"
                            style="max-width: 120px"
                            [(ngModel)]="item.batchSize"
                            (ngModelChange)="onIndirectChange(item)"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="1"
                          />
                          <ng-template #batchTextIndirect>
                            {{
                              item.batchSize != null
                                ? (item.batchSize | number : "1.0-0" : "en-US")
                                : "—"
                            }}
                          </ng-template>
                        </td>

                        <!-- 10) Unit Cost -->
                        <td class="py-2 fw-semibold align-middle">
                          R{{ item.unitCost | number : "1.2-2" : "en-US" }}
                        </td>

                        <!-- Actions -->
                        <td class="py-2 text-nowrap align-middle">
                          <!-- Save -->
                          <button
                            *ngIf="item.isNew || item.isEditing"
                            class="btn-outline-primary success"
                            (click)="saveIndirectRow(item)"
                            title="Save"
                          >
                            <i class="bi bi-floppy"></i>
                          </button>

                          <!-- Edit -->
                          <button
                            *ngIf="!item.isNew && !item.isEditing"
                            class="btn-outline-primary"
                            (click)="startEditIndirectLabour(i)"
                            title="Edit"
                          >
                            <i class="bi bi-pencil-square"></i>
                          </button>

                          <!-- Delete -->
                          <button
                            class="btn-outline-primary danger"
                            (click)="removeIndirectLabour(i)"
                            title="Delete"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>

                      <tr *ngIf="showAlert">
                        <td colspan="11" style="padding: 0">
                          <div
                            class="custom-alert alert-dismissible fade show shadow-lg mt-2"
                            role="alert"
                          >
                            <div class="alert-content">
                              <div class="alert-body">
                                <h4 class="alert-heading">
                                  ⚠️ Target Exceeded
                                </h4>
                                <div
                                  class="alert-message"
                                  [innerHTML]="alertMessage"
                                ></div>
                              </div>
                              <button
                                type="button"
                                class="btn-close alert-close"
                                aria-label="Close"
                                (click)="showAlert = false"
                              ></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- end of scrollable body -->
              </div>
            </div>
            <!-- Variable Overheads Tab -->
            <!-- Variable Overheads Tab -->
            <div
              id="variable"
              class="tab-pane fade"
              [class.show]="isActive('variable')"
              [class.active]="isActive('variable')"
            >
              <div class="border shadow-sm">
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed"
                >
                  <thead class="bg-neutral-800 sticky-top z-3">
                    <tr>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        VOH Name
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Purch. Price
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Purch. Qty
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Price/U
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Usage Qty
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Batch Size
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                      >
                        Unit Cost
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                </table>

                <div class="scrollable-content">
                  <table
                    class="table table-hover align-middle mb-0"
                    style="table-layout: fixed"
                  >
                    <tbody>
                      <tr>
                        <td colspan="8" class="text-center">
                          <button
                            *ngIf="selectedProductId"
                            class="btn btn-teal-gradient btn-sm text"
                            (click)="addNewVariableOH()"
                          >
                            <i class="bi bi-plus"></i> Add New Entry
                          </button>
                          <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                            {{ accountType === 'calculator' ? 'Create or select a product first' : 'Select a product or create one in Inventory' }}
                          </span>
                        </td>
                      </tr>
                      <tr
                        *ngFor="
                          let item of filteredVariableItems;
                          let i = index
                        "
                        class="hover-highlight"
                      >
                        <td class="py-2 fw-semibold">
                          <ng-container
                            *ngIf="item.isLocallyEditing; else nameText"
                          >
                            <select
                              class="form-control form-control-sm custom-select"
                              [(ngModel)]="item.inventoryId"
                              (ngModelChange)="onVOHNameChange(item, $event)"
                            >
                              <option [ngValue]="null" disabled>
                                Select Variable Overhead
                              </option>
                              <option
                                *ngFor="
                                  let vohItem of itemsForVariableOverheadDropdown
                                "
                                [ngValue]="vohItem.itemID"
                              >
                                {{ vohItem.itemName }}
                              </option>
                            </select>
                          </ng-container>
                          <ng-template #nameText>{{
                            item.itemName
                          }}</ng-template>
                        </td>
                        <!-- purchase price -->

                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isLocallyEditing; else priceText"
                          >
                            <div
                              class="input-group input-group-sm"
                              style="max-width: 120px"
                            >
                              <span class="input-group-text">R</span>
                              <input
                                type="number"
                                class="form-control form-control-sm"
                                [(ngModel)]="item.purchasePrice"
                                (ngModelChange)="onVariableOHChange(item)"
                                (focus)="clearZero($event)"
                                (blur)="restoreZeroIfEmpty($event)"
                                min="0"
                                step="0.01"
                                readonly
                              />
                            </div>
                          </ng-container>
                          <ng-template #priceText>
                            R{{
                              item.purchasePrice | number : "1.2-2" : "en-US"
                            }}
                          </ng-template>
                        </td>
                        <td class="py-2">
                          <ng-container
                            *ngIf="
                              item.isLocallyEditing || item.isNew;
                              else quantityText
                            "
                          >
                            <div
                              class="input-group input-group-sm"
                              style="max-width: 120px"
                            >
                              <input
                                type="text"
                                class="form-control form-control-sm"
                                [value]="
                                  (item.purchaseQuantity ?? 0
                                    | number : '1.0-3') +
                                  ' ' +
                                  getQtyLabel(
                                    item.purchaseQuantity ?? 0,
                                    item.purchaseUOMID
                                  )
                                "
                                readonly
                              />
                            </div>
                          </ng-container>
                          <ng-template #quantityText>
                            {{
                              item.purchaseQuantity ?? 0
                                | number : "1.2-2" : "en-US"
                            }}
                            {{
                              getQtyLabel(
                                item.purchaseQuantity ?? 0,
                                item.purchaseUOMID
                              )
                            }}
                          </ng-template>
                        </td>

                        <td class="py-2 fw-semibold">
                          <span *ngIf="item.purchaseUOMID; else noUnit">
                            R{{
                              item.purchasePricePerUnit
                                | number : "1.2-2" : "en-US"
                            }}/{{ getUnitDisplay(item.purchaseUOMID) }}
                          </span>
                          <ng-template #noUnit>
                            R{{
                              item.purchasePricePerUnit
                                | number : "1.2-2" : "en-US"
                            }}
                          </ng-template>
                        </td>

                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isLocallyEditing; else usageQtyText"
                          >
                            <div class="fused-input-group">
                              <input
                                type="number"
                                class="fused-input"
                                [(ngModel)]="item.usageQuantity"
                                (ngModelChange)="onVariableOHChange(item)"
                                (focus)="clearZero($event)"
                                (blur)="restoreZeroIfEmpty($event)"
                                min="0"
                                step="0.001"
                              />
                              <div class="fused-unit-select-wrapper">
                                <select
                                  class="fused-unit-select"
                                  [(ngModel)]="item.uomID"
                                  (ngModelChange)="onVariableOHChange(item)"
                                >
                                  <option [ngValue]="null" disabled>
                                    Select Unit
                                  </option>
                                  <option
                                    *ngFor="let uom of getCompatibleUOMs(getUomCodeById(item.purchaseUOMID))"
                                    [ngValue]="uom.uomID"
                                  >
                                    {{ uom.uomName }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </ng-container>
                          <ng-template #usageQtyText>
                            <div class="d-flex align-items-center gap-1">
                              <span>{{
                                item.usageQuantity ?? 0
                                  | number : "1.0-3" : "en-US"
                              }}</span>
                              <small class="text-muted">{{
                                getQtyLabel(item.usageQuantity ?? 0, item.uomID)
                              }}</small>
                            </div>
                          </ng-template>
                        </td>
                        <td class="py-2">
                          <ng-container
                            *ngIf="item.isLocallyEditing; else unitsText"
                          >
                            <input
                              type="number"
                              class="form-control form-control-sm"
                              style="max-width: 100px"
                              [(ngModel)]="item.batchSize"
                              (ngModelChange)="onVariableOHChange(item)"
                              (focus)="clearZero($event)"
                              (blur)="restoreZeroIfEmpty($event)"
                              min="1"
                              step="1"
                            />
                          </ng-container>
                          <ng-template #unitsText>
                            {{ item.batchSize }}&nbsp;
                            <small class="text-muted">{{
                              item.batchSize === 1 ? "unit" : "units"
                            }}</small>
                          </ng-template>
                        </td>

                        <td class="py-2 text-success fw-semibold">
                          R{{ item.unitCost | number : "1.2-2" : "en-US" }}
                        </td>

                        <td class="py-2 text-nowrap text-start ps-3">
                          <button
                            *ngIf="item.isLocallyEditing"
                            class="btn-outline-primary success"
                            (click)="saveVariableItem(item)"
                            title="Save"
                          >
                            <i class="bi bi-floppy"></i>
                          </button>
                          <button
                            *ngIf="!item.isLocallyEditing"
                            class="btn-outline-primary"
                            (click)="startEditVariableOH(i)"
                            title="Edit"
                          >
                            <i class="bi bi-pencil-square"></i>
                          </button>
                          <button
                            class="btn-outline-primary danger"
                            (click)="removeVariableOH(i)"
                            title="Delete"
                          >
                            <i class="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>

                      <tr *ngIf="showAlert">
                        <td colspan="8" style="padding: 0">
                          <div
                            class="custom-alert alert-dismissible fade show shadow-lg mt-2"
                            role="alert"
                          >
                            <div class="alert-content">
                              <div class="alert-body">
                                <h4 class="alert-heading">
                                  ⚠️ Target Exceeded
                                </h4>
                                <div
                                  class="alert-message"
                                  [innerHTML]="alertMessage"
                                ></div>
                              </div>
                              <button
                                type="button"
                                class="btn-close alert-close"
                                aria-label="Close"
                                (click)="showAlert = false"
                              ></button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- competitor prices tab -->

            <div
              id="competitor"
              class="tab-pane fade"
              [class.show]="isActive('competitor')"
              [class.active]="isActive('competitor')"
            >
              <div *ngIf="competitorSaveError" class="alert alert-danger py-2 px-3 mb-2">
                {{ competitorSaveError }}
              </div>
              <div class="table-responsive border shadow-sm" style="max-height: 330px; overflow-y: auto;">
                <table
                  class="table table-hover align-middle mb-0"
                  style="table-layout: fixed; min-width: 1000px"
                >
                  <thead class="bg-neutral-800 sticky-top z-3">
                    <tr>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 15%"
                      >
                        Competitor Name
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 15%"
                      >
                        Website
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 5%"
                      >
                        Is Active
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 15%"
                      >
                        Target Market Segment
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 18%"
                      >
                        Primary Sales Channel
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 15%"
                      >
                        Geographic Focus
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 text-center"
                        style="width: 10%"
                      >
                        Price (R)
                      </th>
                      <th
                        class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header text-center"
                        style="width: 7%"
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="8" class="text-center">
                        <button
                          *ngIf="selectedProductId"
                          class="btn btn-teal-gradient btn-sm text"
                          (click)="addNewCompetitor()"
                        >
                          <i class="bi bi-plus"></i> Add New Entry
                        </button>
                        <span *ngIf="!selectedProductId" class="text-muted small fst-italic">
                          {{ accountType === 'calculator' ? 'Create or select a product first' : 'Select a product or create one in Inventory' }}
                        </span>
                      </td>
                    </tr>

                    <tr
                      *ngFor="
                        let comp of competitorPrices[selectedProductId!];
                        let i = index
                      "
                      class="hover-highlight"
                    >
                      <!-- Competitor Name -->
                      <td
                        class="py-2 fw-semibold text-center"
                        style="width: 15%"
                      >
                        <ng-container *ngIf="i === 0; else editableName">
                          Your Target Selling Price
                        </ng-container>
                        <ng-template #editableName>
                          <div
                            *ngIf="comp.isNew || comp.isEditing; else nameText"
                            class="input-group input-group-sm"
                            style="max-width: 200px; margin: 0 auto"
                          >
                            <input
                              type="text"
                              class="form-control form-control-sm text-center"
                              [(ngModel)]="comp.name"
                              placeholder="Name"
                            />
                          </div>
                          <ng-template #nameText>{{ comp.name }}</ng-template>
                        </ng-template>
                      </td>

                      <!-- Website -->
                      <td class="py-2 text-center" style="width: 15%">
                        <div
                          *ngIf="comp.isNew || comp.isEditing; else websiteText"
                          class="input-group input-group-sm"
                          style="max-width: 200px; margin: 0 auto"
                        >
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            [(ngModel)]="comp.website"
                            placeholder="Website"
                          />
                        </div>
                        <ng-template #websiteText>{{
                          comp.website
                        }}</ng-template>
                      </td>

                      <!-- Is Active -->
                      <td class="py-2 text-center" style="width: 5%">
                        <div
                          *ngIf="
                            comp.isNew || comp.isEditing;
                            else isActiveText
                          "
                          class="form-check form-switch d-inline-block"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            role="switch"
                            [(ngModel)]="comp.isActive"
                          />
                        </div>
                        <ng-template #isActiveText>
                          <i
                            class="bi"
                            [class.bi-check-circle-fill]="comp.isActive"
                            [class.text-success]="comp.isActive"
                            [class.bi-x-circle-fill]="!comp.isActive"
                            [class.text-danger]="!comp.isActive"
                          ></i>
                        </ng-template>
                      </td>

                      <!-- Target Market -->
                      <td class="py-2 text-center" style="width: 15%">
                        <div
                          *ngIf="
                            comp.isNew || comp.isEditing;
                            else targetMarketSegmentText
                          "
                          class="input-group input-group-sm"
                          style="max-width: 150px; margin: 0 auto"
                        >
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            [(ngModel)]="comp.targetMarketSegment"
                            placeholder="Market Segment"
                          />
                        </div>
                        <ng-template #targetMarketSegmentText>{{
                          comp.targetMarketSegment
                        }}</ng-template>
                      </td>

                      <!-- Primary Sales -->
                      <td class="py-2 text-center" style="width: 18%">
                        <div
                          *ngIf="
                            comp.isNew || comp.isEditing;
                            else primarySalesChannelText
                          "
                          class="input-group input-group-sm"
                          style="max-width: 170px; margin: 0 auto"
                        >
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            [(ngModel)]="comp.primarySalesChannel"
                            placeholder="Sales Channel"
                          />
                        </div>
                        <ng-template #primarySalesChannelText>{{
                          comp.primarySalesChannel
                        }}</ng-template>
                      </td>

                      <!-- Geographic Focus -->
                      <td class="py-2 text-center" style="width: 15%">
                        <div
                          *ngIf="
                            comp.isNew || comp.isEditing;
                            else geographicFocusText
                          "
                          class="input-group input-group-sm"
                          style="max-width: 150px; margin: 0 auto"
                        >
                          <input
                            type="text"
                            class="form-control form-control-sm text-center"
                            [(ngModel)]="comp.geographicFocus"
                            placeholder="Geographic Focus"
                          />
                        </div>
                        <ng-template #geographicFocusText>{{
                          comp.geographicFocus
                        }}</ng-template>
                      </td>

                      <!-- Price -->
                      <td class="py-2 text-center" style="width: 10%">
                        <div
                          *ngIf="comp.isNew || comp.isEditing; else priceText"
                          class="input-group input-group-sm d-inline-flex justify-content-center"
                          style="max-width: 120px; margin: 0 auto"
                        >
                          <span class="input-group-text">R</span>
                          <input
                            type="number"
                            class="form-control form-control-sm text-center"
                            [(ngModel)]="comp.price"
                            (ngModelChange)="checkIfSellingPriceExceedsTarget()"
                            (focus)="clearZero($event)"
                            (blur)="restoreZeroIfEmpty($event)"
                            min="0"
                            step="0.01"
                            (blur)="saveCompetitorRow(comp, i)"
                          />
                        </div>
                        <ng-template #priceText>
                          <span class="text-success fw-semibold">
                            R {{ comp.price | number : "1.2-2" : "en-US" }}
                          </span>
                        </ng-template>
                      </td>

                      <!-- Actions -->
                      <td
                        class="py-2 text-nowrap text-center"
                        style="width: 7%"
                      >
                        <button
                          *ngIf="!comp.isNew && !comp.isEditing"
                          class="btn-outline-primary"
                          (click)="startEditCompetitor(i)"
                          title="Edit"
                        >
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button
                          *ngIf="comp.isNew || comp.isEditing"
                          class="btn-outline-primary"
                          (click)="saveCompetitorRow(comp, i)"
                          title="Save"
                        >
                          <i class="bi bi-floppy"></i>
                        </button>
                        <button
                          *ngIf="i > 0"
                          class="btn-outline-primary danger"
                          (click)="removeCompetitor(i)"
                          title="Delete"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="!competitorPrices[selectedProductId!]?.length">
                      <td colspan="8" class="text-center py-5 bg-neutral-50">
                        <p class="text-muted fs-7 fst-italic">
                          No competitor prices recorded yet
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal for edititing competitor -->
      <!-- Modal for Add / Edit Competitor -->
      <div
        *ngIf="editingCompetitorIndex !== null"
        class="modal-backdrop fade show"
      ></div>
      <div
        *ngIf="editingCompetitorIndex !== null"
        class="modal fade show d-block"
        tabindex="-1"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0 shadow-lg">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title fw-bold">
                {{ isEditingCompetitor ? "Edit Competitor" : "Add Competitor" }}
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                (click)="cancelEditCompetitor()"
              ></button>
            </div>
            <div class="modal-body p-4">
              <form [formGroup]="competitorForm" class="d-grid gap-3">
                <div>
                  <label class="form-label text-muted mb-2"
                    >Competitor Name</label
                  >
                  <input
                    type="text"
                    class="form-control form-control-lg border-2"
                    formControlName="name"
                    placeholder="Enter competitor name"
                  />
                </div>
                <div class="row g-3">
                  <div class="col-12 col-md-6">
                    <label class="form-label text-muted mb-2">Price</label>
                    <div class="input-group border-2">
                      <span
                        class="input-group-text-table bg-transparent border-0 text-muted"
                        >R</span
                      >
                      <input
                        type="number"
                        class="form-control form-control-lg border-0"
                        formControlName="price"
                        step="0.01"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer border-0 px-4 pb-4 pt-0">
              <div class="d-flex gap-3 w-100">
                <button
                  class="btn btn-outline-secondary flex-grow-1"
                  (click)="cancelEditCompetitor()"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary flex-grow-1"
                  (click)="saveCompetitorEdit()"
                  [disabled]="competitorForm.invalid"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
          <!-- competitor prices tab -->
          <div
            id="competitor"
            class="tab-pane fade"
            [class.show]="isActive('competitor')"
            [class.active]="isActive('competitor')"
          >
            <div class="table-responsive">
              <table class="table table-hover align-middle">
                <thead class="bg-neutral-800 sticky-top">
                  <tr>
                    <th
                      class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                    >
                      Competitor Name
                    </th>
                    <th
                      class="text-uppercase small text-white fw-semibold tracking-wide py-3"
                    >
                      Competitor Price (R)
                    </th>
                    <th
                      class="text-uppercase small text-white fw-semibold tracking-wide py-3 actions-header"
                    >
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span>Actions</span>
                        <button
                          class="btn-add"
                          (click)="addNewCompetitor()"
                          title="Add New Entry"
                          [disabled]="!selectedProductId"
                        >
                          <i
                            class="bi bi-plus-lg fw-bold"
                            style="margin-left: 2px; margin-top: 3px"
                          ></i>
                        </button>
                      </div>
                    </th>
                  </tr>
                </thead>
              </table>

              <!-- End Modal -->

              <!-- end modal -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Edit Product Modal -->
  <div *ngIf="showEditProductModal" class="modal-backdrop fade show"></div>
  <div *ngIf="showEditProductModal" class="modal fade show d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title fw-bold">Edit Product</h5>
          <button type="button" class="btn-close btn-close-white" (click)="cancelEditProduct()"></button>
        </div>
        <div class="modal-body p-4">
          <div class="d-grid gap-3">
            <div>
              <label class="form-label text-muted mb-2">Product Name</label>
              <input type="text" class="form-control form-control-lg border-2"
                [(ngModel)]="editProductName" [ngModelOptions]="{standalone: true}"
                placeholder="Product name" />
            </div>
            <div>
              <label class="form-label text-muted mb-2">Selling Price</label>
              <div class="input-group border-2">
                <span class="input-group-text bg-transparent border-0 text-muted">R</span>
                <input type="number" class="form-control form-control-lg border-0"
                  [(ngModel)]="editProductSellingPrice" [ngModelOptions]="{standalone: true}"
                  step="0.01" min="0" placeholder="0.00" />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 px-4 pb-4 pt-0">
          <div class="d-flex gap-3 w-100">
            <button class="btn btn-outline-secondary flex-grow-1" (click)="cancelEditProduct()" [disabled]="isSavingEditProduct">
              Cancel
            </button>
            <button class="btn btn-primary flex-grow-1" (click)="saveEditProduct()"
              [disabled]="isSavingEditProduct || !editProductName?.trim()">
              <span *ngIf="isSavingEditProduct" class="spinner-border spinner-border-sm me-2"></span>
              {{ isSavingEditProduct ? 'Saving...' : 'Save Changes' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- anothr modal for save  -->

  <div
    class="modal-overlay"
    [class.active]="showSaveModal"
    (click)="closeSaveModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Changes</h5>
        <button class="close-btn" (click)="closeSaveModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="modal-intro-text">
          Are you sure you want to save these changes? This will
          <strong class="fw-semibold text-primary">update</strong> in the
          database.
        </p>

        <div
          *ngIf="modalMessage"
          [ngClass]="{
            'status-message-modal-success': isSuccess,
            'status-message-modal-error': isSuccess === false
          }"
        >
          <div
            class="status-message-modal-content"
            [innerHTML]="modalMessage"
          ></div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          class="btn btn-cancel"
          [class.btn-warning]="!isSuccess"
          [disabled]="isSaving"
          (click)="closeSaveModal()"
        >
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="saveChanges(selectedProductId!)"
          [disabled]="isSaving || !isSuccess"
        >
          <span *ngIf="isSaving" class="spinner"></span>
          {{ isSaving ? "Saving..." : "Confirm Changes" }}
        </button>
      </div>
    </div>
  </div>
  <!-- delete modal -->
  <!-- delettion modal -->
  <div
    class="modal-overlay"
    [class.active]="showDeleteConfirm"
    (click)="closeDeleteConfirm()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">Confirm Deletion Changes</h5>
        <button class="close-btn" (click)="closeDeleteConfirm()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="confirmation-text">
          Are you sure you remove this entry? This will
          <strong class="text-danger">delete records</strong> in the database.
        </p>
        <div *ngIf="deleteModalMessage" class="status-message mt-3">
          <div
            [ngClass]="{
              success: isDeleteSaveSuccess,
              error: isDeleteSaveSuccess === false
            }"
          >
            <div class="mx-auto" [innerHTML]="deleteModalMessage"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-cancel" (click)="closeDeleteConfirm()">
          Cancel
        </button>

        <button
          class="btn btn-save"
          (click)="confirmDelete()"
          [disabled]="isSavingDelete"
        >
          <span
            *ngIf="isSavingDelete"
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Confirm
        </button>
      </div>
    </div>
  </div>
  <!-- system message -->
  <div
    class="modal-overlay"
    [class.active]="showMessageModal"
    (click)="closeShowMessageModal()"
  >
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title mx-auto">System Message</h5>
        <button class="close-btn" (click)="closeShowMessageModal()">
          <svg width="16" height="16" viewBox="0 0 16 16">
            <path
              fill="currentColor"
              d="M14.7 1.3c-.4-.4-1-.4-1.4 0L8 6.6 2.7 1.3C2.3.9 1.7.9 1.3 1.3s-.4 1 0 1.4L6.6 8l-5.3 5.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3s.5-.1.7-.3L8 9.4l5.3 5.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4L9.4 8l5.3-5.3c.4-.4.4-1 0-1.4z"
            />
          </svg>
        </button>
      </div>

      <div class="modal-body mx-auto">
        <strong class="confirmation-text mx-auto">
          <div class="mx-auto" [innerHTML]="alertInfo"></div>
        </strong>
      </div>
      <div class="modal-footer">
        <button class="btn btn-save mx-auto" (click)="closeShowMessageModal()">
          Close
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="isLoadingData" class="app-spinner-overlay">
    <div class="app-loading-spinner"></div>
  </div>
</div>
